import { registerQuery, useQuery } from 'data-fetching-client';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
const unauthedUser = {
  gates: [],
  portal: {},
  user: {
    created_at: 1,
    email: '',
    emails: [],
    first_name: '',
    lang_enabled: false,
    last_name: '',
    locale: '',
    partner: false,
    roles: [],
    scopes: [],
    teams: [],
    user_id: 0,
    verified: false
  }
};
export const HUBLESS_USER_INFO = registerQuery({
  fieldName: 'userInfo',
  args: [],

  fetcher() {
    return noAuthApiClient.get('/login-verify/user-info').then( // @ts-expect-error ts-migrate(2339) FIXME: Property 'user' does not exist on type 'JSON'.
    ({
      user
    }) => {
      return Object.assign({}, unauthedUser, {
        user: Object.assign({}, unauthedUser.user, {
          email: user.emails[0],
          emails: user.emails,
          first_name: user.firstName,
          lang_enabled: user.languageEnabled,
          last_name: user.lastName,
          locale: user.locale,
          user_id: user.id,
          verified: user.verifiedAt !== null
        })
      });
    })
    /**
     * We expect this call to fail if the user is not logged in.
     * We return a barebones user object in that case.
     */
    .catch(() => unauthedUser);
  }

});
export const getUserInfo = client => client.query({
  query: HUBLESS_USER_INFO
}).then(({
  data: {
    userInfo: {
      user
    }
  }
}) => user);
export const useUserInfo = () => {
  const {
    data,
    loading: userInfoLoading,
    error: userInfoError
  } = useQuery(HUBLESS_USER_INFO);
  let userInfo = null;

  if (data && data.userInfo) {
    userInfo = data.userInfo.user;
  }

  return {
    userInfo,
    userInfoLoading,
    userInfoError
  };
};